module.exports = __webpack_public_path__ + "img/current_hub.dbcf1a09.png";